// Picks the student's active/current enrollment (matching the rest of the app,
// which does enrollments.find(e => e.current)), falling back to the first row.

export const getCurrentEnrollment = (student) =>
  (student?.enrollments || []).find((e) => e.current) ||
  student?.enrollments?.[0] ||
  null;

// "MERN Stack · Full-Stack Structure · B12" — skips missing parts, '' if none.
export const formatEnrollment = (student) => {
  const e = getCurrentEnrollment(student);
  if (!e) return '';
  return [
    e.course?.courseName,
    e.batchStructure?.name,
    e.batch?.batchNumber != null ? `B${e.batch.batchNumber}` : null,
  ]
    .filter(Boolean)
    .join(' · ');
};
